import {
  HeadingGroup,
  ModalLayout,
  NavGroup,
  OffCanvasLayout,
  Pagination,
  SearchFilters,
} from "@wac-ui-dashboard/wac_component_library";
import React from "react";
import useRecheck from "./useRecheck";
import { FaSort } from "react-icons/fa";
import OrderColumn from "../../Global/OrderColumn";
import Filter from "./Filter";
import Style from "./recheck.module.scss";
import RecheckDetails from "./Details/Recheck";
import { Link } from "react-router-dom";
import StockReceipt from "./StockReceipt";
import RecheckOfficeSlip from "./RecheckOfficeSlip/RecheckOfficeSlip";
import CancelRecheckModal from "./CancelRecheckModal";
import ExcelUpload from "./ExcelUpload";
import FilterButton from "../../Global/FilterButton";
import { Table } from "../../Global/Table";
import AdditionalDocumentUpload from "./AdditionalDocumentUpload";
// import ReissueDetails from "./Details/Reissue";

const Recheck = () => {
  const {
    inputData,
    tableFields,
    recheckList,
    isFetching,
    recheckState,
    filterShow,
    filterCount,
    showEditModal,
    tabNavs,
    paginationOptions,
    StockReceiptRef,
    recheckOfficeSlipRef,
    updateConfig,
    loadingdownload,
    dispatch,
    getRow,
    refetch,
    handleSort,
    handleClose,
    handleSearch,
    setFilterShow,
    handlePageSize,
    handlePagination,
    handleClearClick,
    handleReissueModal,
    handleRecheckModal,
    handleEditColumnsClick,
    updateRecheckTableData,
    handleOfficeSlipModal,
    handleSelectedId,
    handleCancelModal,
    handleCancelModalClose,
    selectedItem,
    handleExcelFileDownload,
    handleExcelUploadClick,
    handleExcelUploadModalClose,
    handleFilterClear,
    handleOpenUploadModal,
    handleAdditionalExcelUploadModalClose,
  } = useRecheck();

  return (
    <>
      <HeadingGroup title={"Recheck"} className={`pro-mb-4`} />
      <div className="col-auto pro-pt-3 pro-pb-6">
        <div className={`${Style.main_container}`}>
          <NavGroup navigations={tabNavs} type={"type-2"} Link={Link} />
        </div>
        <div className="row gx-2">
          <div className="col-auto">
            <SearchFilters
              onSearchInput={handleSearch}
              showActions={true}
              showFilters={true}
              handleActionClick={handleEditColumnsClick}
              searchInputProps={{
                value: inputData,
                placeholder:
                  recheckState?.activeTab === "certificate"
                    ? "Search Certificate Number, Shop"
                    : "Search Gli Number, Supplier ",
              }}
              // loading={isLoading}
              SearchIcon={
                <span className="material-symbols-outlined"> search </span>
              }
              handleClear={handleClearClick}
              showDateRange={false}
            />
          </div>
          <div className="col-auto">
            <FilterButton
              onClick={() => setFilterShow(true)}
              filterCount={filterCount}
              className={Style.filter_btn}
            />
          </div>
          <div className="col-auto pro-d-flex pro-items-center pro-h-100">
            <button
              className="pro-btn pro-btn-link"
              onClick={handleFilterClear}
            >
              Clear
            </button>
          </div>
          <div className="col-auto">
            {recheckState?.activeTab === "stock-receipt" &&
              recheckState?.selectedId.length > 0 &&
              !recheckState?.cancelstockState && (
                <>
                  <button
                    className={`pro-btn pro-btn-outline pro-h-100  pro-items-center  ${Style.filter_btn}`}
                    onClick={() => handleCancelModal()}
                  >
                    <span className="material-symbols-outlined">cancel</span>
                    <span>Cancel Stock</span>
                  </button>
                </>
              )}
          </div>
          <div className="col-auto">
            {recheckState?.activeTab === "stock-receipt" &&
              recheckState?.selectedId.length > 0 && (
                <>
                  <button
                    className={`pro-btn pro-btn-outline pro-h-100  pro-items-center  ${Style.filter_btn}`}
                    onClick={() => {
                      handleExcelUploadClick();
                    }}
                  >
                    <span className="material-symbols-outlined">upload</span>
                    <span>Excel Upload</span>
                  </button>
                </>
              )}
          </div>
          <div className="col-auto">
            {recheckState?.activeTab === "stock-receipt" &&
              recheckState?.selectedId.length > 0 && (
                <>
                  <button
                    className={`pro-btn pro-btn-outline pro-h-100  pro-items-center  ${Style.filter_btn} ${loadingdownload ? "loading" : ""}`}
                    onClick={() => handleExcelFileDownload()}
                  >
                    <span className="material-symbols-outlined">download</span>
                    <span>Excel Download</span>
                  </button>
                </>
              )}
          </div>
        </div>

        <Table
          multiSelect={true}
          data={recheckList?.data?.data || []}
          uniqueID={"_id"}
          fields={tableFields}
          SortIcon={<FaSort />}
          clear={recheckState.clearSelection}
          editIcon={
            recheckState?.activeTab === "certificate" ? (
              <span className="material-symbols-outlined">change_circle</span>
            ) : (
              <span className="material-symbols-outlined">print</span>
            )
          }
          assignIcon={
            recheckState?.activeTab === "certificate" ? (
              <span className="material-symbols-outlined">arrow_split</span>
            ) : (
              <span className="material-symbols-outlined">print</span>
            )
          }
          deleteIcon={<span className="material-symbols-outlined">print</span>}
          handleSort={handleSort}
          getRow={getRow}
          loading={isFetching}
          perpage={recheckList?.currentPageSize}
          assignable={true}
          editable={true}
          editText={
            recheckState?.activeTab === "certificate" ? "Reissue" : "Report"
          }
          assignText={
            recheckState?.activeTab === "certificate"
              ? "Recheck"
              : "Stock Receipt Slip"
          }
          deleteText={`Office Slip`}
          handleEdit={handleReissueModal}
          handleSelect={
            recheckState?.activeTab === "stock-receipt"
              ? handleSelectedId
              : () => {}
          }
          handleAssign={handleRecheckModal}
          handleDelete={handleOfficeSlipModal}
          deletable={recheckState?.activeTab === "certificate" ? false : true}
          showCheckBox={true}
          // extraClasssName="table-wrapper tab-tbl-h"
          stickyActionBtns={true}
          tabFilter={true}
        />
        <ModalLayout show={showEditModal} handleClose={handleEditColumnsClick}>
          <div className="pro-m-5">
            <OrderColumn
              title={"Choose which columns you see"}
              refetchData={refetch}
              tableFields={recheckList?.data?.fields}
              moduleId={recheckList?.data?.module_id}
              updateData={updateRecheckTableData}
            />
          </div>
        </ModalLayout>
        <ModalLayout
          show={recheckState?.showCancelModal}
          handleClose={handleCancelModalClose}
          title={"Cancel Recheck"}
          backdrop="static"
          closeIcon={<span className="material-symbols-outlined">close</span>}
        >
          <div className="pro-m-5">
            <CancelRecheckModal
              handleClose={handleCancelModalClose}
              refetch={refetch}
              selectedId={recheckState?.selectedId}
              dispatch={dispatch}
              updateConfig={updateConfig}
            />
          </div>
        </ModalLayout>

        {recheckList?.data?.data?.length > 0 && (
          <Pagination
            currentPage={recheckState?.currentPage}
            totalPageCount={Math.ceil(
              recheckList?.data?.total_count / recheckState?.currentPageSize,
            )}
            onPageChange={handlePagination}
            options={paginationOptions}
            onActionChange={handlePageSize}
            center
          />
        )}
        <OffCanvasLayout
          show={recheckState?.showAddRecheckModal}
          handleClose={handleClose}
          title="Recheck"
        >
          <RecheckDetails refetch={refetch} selectedItem={selectedItem} />
        </OffCanvasLayout>
        <OffCanvasLayout
          show={recheckState?.showAddReissueModal}
          handleClose={handleClose}
          title="Reissue"
        >
          <RecheckDetails refetch={refetch} />
        </OffCanvasLayout>
        <OffCanvasLayout
          show={filterShow}
          title={"Filter"}
          handleClose={() => {
            setFilterShow(false);
          }}
          closeIcon={<span className="material-symbols-outlined">close</span>}
        >
          <Filter setShowform={setFilterShow} />
        </OffCanvasLayout>
      </div>
      <div className={Style.print}>
        <StockReceipt stockPrintRef={StockReceiptRef} />
        <RecheckOfficeSlip recheckOfficeSlipRef={recheckOfficeSlipRef} />
      </div>
      <ModalLayout
        show={recheckState.excelUploadModal}
        handleClose={handleExcelUploadModalClose}
        title={`Upload Documents`}
        closeIcon={<span className="material-symbols-outlined"> close </span>}
      >
        <div className="pro-m-5">
          <ExcelUpload />
        </div>
      </ModalLayout>
      <ModalLayout
        show={recheckState.additionalExcelUploadModal}
        handleClose={handleAdditionalExcelUploadModalClose}
        title={`Upload Documents`}
        closeIcon={<span className="material-symbols-outlined"> close </span>}
      >
        <div className="pro-m-5">
          <AdditionalDocumentUpload />
        </div>
      </ModalLayout>
    </>
  );
};

export default Recheck;
